import { createSlice } from '@reduxjs/toolkit';

import { addStateFetch } from '@webapp/account/src/resources/store-utils';

import { initialLogicCondition } from '@webapp/common/entities/logic';
import { updateItemInArray } from '@webapp/common/lib/utils';

import {
    addLogicLinkParamsCondition,
    changeLogicLinkParamsConditionParam,
    getLinkParamsWithoutValues,
    loadLinkParamsLogic,
    loadLogicPagesAndQuestionsData,
    removeLogicLinkParamsCondition,
} from './async';
import { initialState } from './links';

export const linksSlice = createSlice({
    name: 'logic-link-params',
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        addStateFetch(
            builder
                .addCase(getLinkParamsWithoutValues.fulfilled, (s, { payload: items }) => {
                    s.items = items;
                    s.linkParamsLoaded = true;
                    s.linkParamsLoading = false;
                })
                .addCase(getLinkParamsWithoutValues.pending, (s) => {
                    s.linkParamsLoading = true;
                })
                .addCase(getLinkParamsWithoutValues.rejected, (s) => {
                    s.linkParamsLoading = false;
                })
                .addCase(loadLogicPagesAndQuestionsData.pending, (s) => {
                    s.fetchPages = true;
                })
                .addCase(loadLogicPagesAndQuestionsData.rejected, (s) => {
                    s.fetchPages = false;
                })
                .addCase(loadLogicPagesAndQuestionsData.fulfilled, (s, { payload: items }) => {
                    s.fetchPages = false;
                    s.pages = items.pages;
                    s.questions = items.questions;
                    if (!s.fetchLogics) {
                        s.logics = s.logics.map((logic) => ({
                            ...logic,
                            completeText:
                                typeof logic.completeText !== 'string'
                                    ? logic.completeText
                                    : logic.completeText.replace(/\{Q\-([0-9]+)\}/gi, (_match, id) => {
                                          const q = items.questions.find((q) => q.id === parseInt(id, 10));
                                          return `{Q${q.order}}`;
                                      }),
                            disqualText:
                                typeof logic.disqualText !== 'string'
                                    ? logic.disqualText
                                    : logic.disqualText.replace(/\{Q\-([0-9]+)\}/gi, (_match, id) => {
                                          const q = items.questions.find((q) => q.id === parseInt(id, 10));
                                          return `{Q${q.order}}`;
                                      }),
                        }));
                    }
                })
                .addCase(loadLinkParamsLogic.pending, (s) => {
                    s.fetchLogics = true;
                })
                .addCase(loadLinkParamsLogic.rejected, (s) => {
                    s.fetchLogics = false;
                })
                .addCase(loadLinkParamsLogic.fulfilled, (s, { payload: { logics } }) => {
                    s.fetchLogics = false;
                    s.logics = logics;
                    if (!s.fetchPages) {
                        s.logics = s.logics.map((logic) => ({
                            ...logic,
                            completeText:
                                typeof logic.completeText !== 'string'
                                    ? logic.completeText
                                    : logic.completeText.replace(/\{Q\-([0-9]+)\}/gi, (_match, id) => {
                                          const q = s.questions.find((q) => q.id === parseInt(id, 10));
                                          return `{Q${q.order}}`;
                                      }),
                            disqualText:
                                typeof logic.disqualText !== 'string'
                                    ? logic.disqualText
                                    : logic.disqualText.replace(/\{Q\-([0-9]+)\}/gi, (_match, id) => {
                                          const q = s.questions.find((q) => q.id === parseInt(id, 10));
                                          return `{Q${q.order}}`;
                                      }),
                        }));
                    }
                })
                .addCase(addLogicLinkParamsCondition.fulfilled, (s, { payload: { id, ...condition } }) => {
                    s.logics.push({ ...initialLogicCondition, ...condition, id });
                })
                .addCase(removeLogicLinkParamsCondition.fulfilled, (s, { payload: { conditionId } }) => {
                    s.logics = s.logics.filter((l) => l.id !== conditionId);
                })
                .addCase(
                    changeLogicLinkParamsConditionParam.fulfilled,
                    ({ logics }, { payload: { conditionId, params } }) => {
                        updateItemInArray(logics, conditionId, (l) => {
                            Object.assign(l, params);
                        });
                    },
                ),
        ),
});
